import React from 'react';
import moment from 'moment';
import { useCustomHooks } from '../../../../../functions/Hooks';

const RawClosingStockPrint = ({
  name,
  closingStockRef,
  closingStockData,
  branch
}) => {
  const { roundOffPrice } = useCustomHooks();
  
  return (
    <>
      {/* Print Day End Raw Material Report Start */}
      <div className="d-none">
        <div ref={closingStockRef}>
          {closingStockData && (
            <div className="fk-print">
              <div style={{width:"98%"}}>
                <div className="row sm-text">
                  <div className="col-12">
                    <div className="mt-2 table-text font-weight-bold text-uppercase text-center mb-2">
                      Variance Report
                    </div>
                    <div className="mt-2 table-text font-weight-bold text-uppercase text-center mb-2">
                      {branch ?? ""}
                    </div>
                    <div className="mt-2 table-text font-weight-bold text-uppercase text-center mb-2">
                      Print Date: {moment(new Date()).format('DD-MM-YYYY hh:mm A')}
                    </div>
                    <div className="mt-2 table-text font-weight-bold text-uppercase text-center mb-2">
                      {name}
                    </div>                       
                  </div>
                  <div className="col-12">
                    <table className="table table-bordered-sm table-hover">
                      <thead className="align-middle">
                          <th scope="col"
                            className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                            Item
                          </th>
                          <th scope="col"
                            className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                            Unit
                          </th>
                          <th scope="col"
                            className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                            Opening
                          </th>

                          <th scope="col"
                            className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                            Purchase
                          </th>

                          <th scope="col"
                            className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                            Trans In
                          </th>

                          <th scope="col"
                            className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                            Prod In
                          </th>

                          <th scope="col"
                            className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                            Total
                          </th>

                          <th scope="col"
                            className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                            Trans Out
                          </th>

                          <th scope="col"
                            className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                            Sale
                          </th>

                          <th scope="col"
                            className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                            Made Void
                          </th>

                          <th scope="col"
                            className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                            Discard
                          </th>

                          <th scope="col"
                            className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                            Production
                          </th>

                          <th scope="col"
                            className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                            Total
                          </th>

                          <th scope="col"
                            className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                            Sys End Count
                          </th>

                          <th scope="col"
                            className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                            Phy End Count
                          </th>

                          <th scope="col"
                            className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                            Diff
                          </th>

                          {/* <th scope="col"
                            className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                            Amt
                          </th> */}
                      </thead>                                                           
                      {
                        closingStockData &&
                        closingStockData !== null &&
                        closingStockData && closingStockData?.map((value)=>{  
                        const totalIn = parseFloat(value?.Opening) + parseFloat(value?.Purchase) + parseFloat(value?.TrasferInn) + parseFloat(value?.ProductionInn); 
                        const totalOut =  parseFloat(value?.TrasferOut) + parseFloat(value?.Sales) + parseFloat(value?.MadeVoid) + parseFloat(value?.Discard) + parseFloat(value.Production);
                        const sysEndCount = totalIn - totalOut;
                        const diff = parseFloat(value?.PhysicalEndCount) - sysEndCount;
                        return(
                          <tbody className="align-middle">
                            <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{value?.name}</td>
                            <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{value?.unit ?? ""}</td>
                            <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{value?.Opening}</td>
                            <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(value?.Purchase)}</td>
                            <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(value?.TrasferInn)}</td>
                            <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(value?.ProductionInn)}</td>
                            <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(totalIn)}</td>
                            <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(value?.TrasferOut)}</td> 
                            <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(value?.Sales)}</td>
                            <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(value?.MadeVoid)}</td>
                            <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(value?.Discard)}</td>
                            <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(value?.Production)}</td>
                            <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(totalOut)}</td>
                            <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(sysEndCount)}</td>
                            <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{value?.PhysicalEndCount}</td>
                            <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(diff)}</td>
                            {/* <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>0</td> */}
                          </tbody>
                          )
                        })
                      }
                    </table>                       
                  </div>                   
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default RawClosingStockPrint